/* CUSTOM JV (Robert, 17 sept) — pagina cu produse (colectie), doar pe mobil: pozele primului card aluneca
   spre stanga cu 1/3 si revin, ca sa arate ca se poate da swipe pe carduri. O singura data pe sesiune.
   (Pe pagina unui produs nu mai ruleaza: acolo swipe-ul e de la sine inteles.)
   Card Horizon = <product-card> ... <slideshow-slides> cu slide-uri <slideshow-slide>. */
(function () {
  var KEY = 'jv-card-hint';
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) { /* noop */ }

  function init() {
    var cards = document.querySelectorAll('product-card');
    var scroller = null;
    var slides = [];
    for (var i = 0; i < cards.length && !scroller; i++) {
      var sc = cards[i].querySelector('slideshow-slides');
      if (!sc) continue;
      var visible = Array.prototype.filter.call(sc.children, function (el) { return el.offsetWidth > 0; });
      if (visible.length >= 2) { scroller = sc; slides = visible; }
    }
    if (!scroller || !('IntersectionObserver' in window) || !Element.prototype.animate) return;

    var cancelled = false;
    var running = [];
    function cancel() {
      cancelled = true;
      running.forEach(function (a) { a.cancel(); });
    }
    scroller.addEventListener('touchstart', cancel, { once: true, passive: true });
    scroller.addEventListener('pointerdown', cancel, { once: true });

    function animate() {
      if (cancelled || scroller.scrollLeft > 4) return;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* noop */ }
      var frames = [
        { transform: 'translateX(0)' },
        { transform: 'translateX(-33.333%)', offset: 0.42 },
        { transform: 'translateX(-33.333%)', offset: 0.58 },
        { transform: 'translateX(0)' }
      ];
      running = slides.slice(0, 3).map(function (slide) {
        return slide.animate(frames, { duration: 1500, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' });
      });
    }

    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var img = slides[0].querySelector('img');
      var go = function () { setTimeout(animate, 700); };
      if (!img || img.complete) go(); else img.addEventListener('load', go, { once: true });
    }, { threshold: 0.6 });
    io.observe(scroller);
  }

  if (document.readyState === 'complete') init(); else window.addEventListener('load', init);
})();
